import React from 'react';
import { MultiCombobox } from '~/components/uie-fix/MultiCombobox';
import { useFilterField } from '../../hooks/useFilterField';
import { useAgencies } from '../../data/useAgencies';
import useDebouncedState from '~/lib/useDebouncedState';

const API_REQUEST_DELAY = 300;

export const AgencyFilter = () => {
  const [, debouncedSearchInput, setSearchInput] = useDebouncedState('', API_REQUEST_DELAY);
  const { value, setValue } = useFilterField('agency', 'PrimaryFilter');
  const { agencies } = useAgencies({ 'filter[q]': debouncedSearchInput, 'page[size]': 10, 'page[number]': 1 });

  return (
    <MultiCombobox
      value={value}
      aria-label="Agency"
      placeholder="Agency"
      onSearch={(query) => {
        // TODO: temp bug patch for UIE-1862
        if (query !== '[object Object]') setSearchInput(query);
      }}
      onChange={(selectedItems) => setValue(selectedItems.filter((s) => !!s.trim()))}
      filterOption={(o) => !debouncedSearchInput || o.label.toLowerCase().includes(debouncedSearchInput.toLowerCase())}
      placeholderVariant="indicator"
    >
      {agencies.length > 0 ? (
        agencies.map((program) => <MultiCombobox.Option label={program.name} value={program.id} key={program.id} />)
      ) : (
        // TODO: temp bug patch for UIE-1862
        <MultiCombobox.Option label="SELECT" value="SELECT" />
      )}
    </MultiCombobox>
  );
};
